const markAsMissingKey = (str: string) => `!${str}!`

type StringsMap = { [key: string]: string }
export const createTranslationFn = (
  translations: StringsMap,
  context: StringsMap = {},
): ((key: string) => string) => {
  return (key) => {
    const translation = translations[key]

    if (!translation) {
      return markAsMissingKey(key)
    }

    return translation.replace(
      // matches `var` in "<%=var%>"
      /<%=([^%]+)%>/g,
      (_, variable) => context[variable] ?? markAsMissingKey(variable),
    )
  }
}
